import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">

                {/* Column 1 */}
                <div className="footer-column">
                    <h4>Support</h4>
                    <Link to="/help">Help Center</Link>
                    <Link to="/safety">Safety Information</Link>
                    <Link to="/contact">Contact Us</Link>
                </div>

                {/* Column 2 */}
                <div className="footer-column">
                    <h4>Community</h4>
                    <a href="/">Care Resources</a>
                    <a href="/">Family Testimonials</a>
                    <a href="/">Senior Living Guide</a>
                </div>

                {/* Column 3 */}
                <div className="footer-column">
                    <h4>Hosting</h4>
                    <a href="/">List Your AFH</a>
                    <a href="/">Owner Resources</a>
                    <a href="/">Regulations</a>
                </div>

            </div>

            <div className="footer-bottom">
                <span>© {new Date().getFullYear()} Washington AFH Listings</span>
                <div className="footer-socials">
                    <a href="/">Facebook</a>
                    <a href="/">Instagram</a>
                    <a href="/">LinkedIn</a>
                </div>
            </div>
        </footer>
    );
}